The remuneration offered for the position.

This information allows us to better forecast the performance of the advertisement products.
